/// <reference types="cordova-plugin-autostart/types"/>
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { ObjectStorage } from 'shared/api/object-storage';
import { select_ui_settings } from '../redux/settings-actions';
import { isAndroidApp, isIOSApp, isMobileApp } from 'webui/utils/version';
function WidgetsHandlerImpl(props) {
    const { device_ids, enable_confirmation, device_state_sounds } = props;
    function showWidgets(device_ids, enable_confirmation, device_state_sounds) {
        const host = ObjectStorage.get(window.localStorage, 'server_url');
        const auth_token = ObjectStorage.get(window.localStorage, 'auth_token');
        const startWidgets = () => {
            window.ZontNotificationWidget?.start_widget((result) => { }, (error) => console.log(`ERROR STARTING WIDGET: ${error}`), host, auth_token, UI_VERSION || 'dev', device_ids, enable_confirmation, device_state_sounds);
        };
        startWidgets();
    }
    useEffect(() => {
        if (isMobileApp() && isAndroidApp()) {
            showWidgets(device_ids, enable_confirmation, device_state_sounds);
        }
    }, [device_ids, enable_confirmation, device_state_sounds]);
    return null;
}
const empty = {};
export const WidgetsHandler = connect((state) => ({
    device_ids: state.app_settings.settings.widget_device_ids,
    enable_confirmation: state.ui_settings.longpress ?? isMobileApp(),
    device_state_sounds: select_ui_settings(state)?.device_state_sounds ?? empty,
}))(WidgetsHandlerImpl);
export const register_autostart = () => {
    if (isIOSApp()) {
        return;
    }
    if (window.cordova?.plugins.autoStart == null) {
        return;
    }
    window.cordova?.plugins.autoStart.enableService('com.microline.zont.notificationwidget.WidgetService');
};
